/* RES product cards: skeleton reveal + scroll reveal (shared by all card-product renders) */
(function () {
  if (window._resSkeletonInit) return;
  window._resSkeletonInit = true;

  var revealObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-revealed');
        revealObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.05 });

  function initCard(card) {
    var img = card.querySelector('.card-product__image--primary');
    if (!img) { card.classList.add('skeleton-done'); return; }
    function done() { card.classList.add('skeleton-done'); }
    if (img.complete && img.naturalWidth > 0) { done(); }
    else { img.addEventListener('load', done); img.addEventListener('error', done); }
  }

  function initAll() {
    document.querySelectorAll('.card-product').forEach(function (card) {
      initCard(card);
      if (card.hasAttribute('data-reveal')) revealObserver.observe(card);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
